import { render, staticRenderFns } from "./MallHotelBrand.vue?vue&type=template&id=7a1e1359&scoped=true"
import script from "./MallHotelBrand.vue?vue&type=script&lang=js"
export * from "./MallHotelBrand.vue?vue&type=script&lang=js"
import style0 from "./MallHotelBrand.vue?vue&type=style&index=0&id=7a1e1359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e1359",
  null
  
)

export default component.exports